<template>
    <div class="activitas-config w-full">
        <div class="flex flex-col w-full text-lg mb-12">
            <div class="flex flex-row  justify-start items-center">
                <label for="uebung_title" class="w-96 text-xl mb-2 text-grey-700 font-bold">Name der Übung*</label>
                <input id="uebung_title" required type="text" v-model="store.uebung.title" class="input-light p-2 w-full">
            </div>
            <div class="flex flex-row  justify-start items-center mt-8">
                <label for="uebung_title" class="w-96 text-xl mb-2 text-grey-700 font-bold">Vokabelauswahl</label>
                <Button severity="secondary" label="Partikel und Pronomina entfernen" icon="fas fa-trash" class="p-3 w-full" @click="removeWortarten">
                </Button>
            </div>
        </div>
        <div class="text-base leading-relaxed">
            Mit dem Klick auf die Symbole können Sie einstellen, welche Aktivität zu welcher Vokabel gehören soll. Mit
            <i class="hi hi-trash"></i> können Sie ein Kärtchen löschen.
        </div>
        <div v-if="isLoading" class="flex flex-row items-center justify-center my-6">
            <loading-comet></loading-comet>
        </div>
        <div class="activitas-config__page-grid no-outline mt-5">
            <div class="activitas-config__page-row flex flex-row text-lg h-10"
                v-for="(word, index) in store.uebung.content_data">
                <div class="flex flex-row justify-start w-2/5 p-1">
                    <div class="font-serif font-bold mr-2" v-html="word.lemma"></div>
                    (
                    <div class="italic capitalize" v-html="word.wortart"></div>
                    )
                </div>
                <div class="w-2/5 flex flex-row justify-center p-1 text-2xl">
                    <button @click="changeActivity(index, 'explain')"
                        class="text-grey-300 hover:text-secondary-600 mx-1">
                        <i :class="{ 'text-secondary_color': word.activity === 'explain' }" class="hi hi-lips"
                            aria-hidden="true"></i></button>
                    <button @click="changeActivity(index, 'mime')" class="text-grey-300 hover:text-secondary-600 mx-1">
                        <i :class="{ 'text-secondary_color': word.activity === 'mime' }"
                            class="fa fa-american-sign-language-interpreting" aria-hidden="true"></i>
                    </button>
                    <button @click="changeActivity(index, 'draw')" class="text-grey-300 hover:text-secondary-600 mx-1">
                        <i :class="{ 'text-secondary_color': word.activity === 'draw' }"
                            class="hi hi-board-draw"></i></button>
                    <button @click="changeActivity(index, 'joker')" class="text-grey-300 hover:text-secondary-600 mx-1">
                        <i :class="{ 'text-secondary_color': word.activity === 'joker' }" class="fa fa-question-circle"
                            aria-hidden="true"></i></button>
                </div>
                <div class="w-1/5 flex flex-row justify-end p-1">
                    <button class="activitas-config_remove-button text-2xl text-grey-500 hover:text-secondary-600"
                        @click="remove(word)"><i class="hi hi-trash"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from "../../../../../resources/js/hermeneus.eventbus/eventbus.js";
import { useUebungActivitasCreateStore } from "./stores/uebungActivitasCreateStore.js";
import { haxiosAPIClient } from "@js/haxios/haxios.js";

export default {
    name: "uebung-activitas-config",
    components: {},
    data() {
        return {
            store: useUebungActivitasCreateStore(),
            isLoading: false,

        }
    },
    computed: {
        isInValidState() {
            return this.store.uebung.title !== '' && this.store.uebung.content_data.length > 0
        },
        latin_lemma_collection() {
            return this.store.getLatinLemmaCollection
        }
    },
    methods: {
        createContentData() {
            this.isLoading = true;
            haxiosAPIClient.post('/uebungen/uebung-activitas/create-content-data', {
                latin_lemma_collection: this.store.latin_lemma_collection
            }).then((response) => {
                this.isLoading = false;
                this.store.uebung.content_data = response.data;
                this.store.setUebung(this.store.uebung);
            });
        },
        removeWortarten() {
            const filteredData = this.store.uebung.content_data.filter((word) => {
                return word.wortart !== 'partikel' && word.wortart !== 'pronomen';
            });
            this.store.updateContentData(filteredData);
        },
        changeActivity(index, activity) {
            const newContentData = [...this.store.uebung.content_data];
            newContentData[index].activity = activity;
            this.store.updateContentData(newContentData);
        },
        remove(remove_word) {
            const filteredData = this.store.uebung.content_data.filter((word) => {
                return word !== remove_word;
            });
            this.store.updateContentData(filteredData);
        },
        updateContentData() {
            EventBus.$emit('ContentDataChanged', this.store.uebung.content_data);
        },
    
    },
    mounted() {
        this.createContentData();
        EventBus.$on('ContentDataChanged', (content_data) => {
            this.store.updateContentData(content_data);
        });
 
    }
}
</script>

<style scoped></style>